import { render, staticRenderFns } from "./CopyFromGroupModal.vue?vue&type=template&id=d216213a&"
import script from "./CopyFromGroupModal.vue?vue&type=script&lang=js&"
export * from "./CopyFromGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports